import { Case } from 'services';
export const CaseGamerPicMock: Case[] = [
  {
    id: 'CGP-001',
    tenant: {
      tenantId: '488296E409C5C8B9',
      displayName: 'name',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4B',
      displayName: 'tname'
    },
    subject: {
      subjectId: 'guid',
      subjectType: 'GamerPic',
      subjectValue:
        'https://images-eds-ssl.xboxlive.com/image?url=Hr2eiH8yWKd4q_oa.xgbMtnIkx5SPlvJWiOeyM.w6KvZLxLwmz4_G2b14AgHS3tRaQ0lV8XFjL0_5lnSWidehP77QuMhO81UAHSthsrglD3xRz7FG4tc_FCQ2D6HNjpvHaSb7tuZHlh2nN2Vp7g6btb6yIe1cT3sHZB7W5RF5BI-&format=jpg&h=253&w=253',
      subjectLabels: [],
      subjectOwners: [
        {
          userId: '0001',
          userType: 'Xuid',
          username: 'testgamertag1'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-11-07T19:35:52.1725026Z',
    caseAssignedStartTime: '2019-11-07T19:35:52.1728898Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {
      type: 'username',
      payload: {
        id: 'cid-00000000566b6c4c',
        username: 'Test First Test last',
        locale: '',
        profileImageUri:
          'https://cid-00000000566b6c4c.users.storage.live.com/users/0x00000000566b6c4c/myprofile/expressionprofile/profilephoto:Win8Static,UserTileMedium,UserTileStatic/MeControlXXLUserTile?ck=1&ex=24'
      }
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
